import { Box, Skeleton, Stack } from "@mui/material";

export default function ProjectReviewVisitV2FunctionListItemSkeleton() {
    return (
        <Box
            padding={2}
            sx={theme => ({
                borderBottom: `1px solid ${theme.palette.divider}`,
            })}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" columnGap={2}>
                <Stack flexGrow={1}>
                    <Skeleton variant="text" width={80} height={20} />
                    <Skeleton variant="text" width={160} height={24} />
                </Stack>
            </Stack>
        </Box>
    );
}
